export default __webpack_public_path__ + "static/media/icone-doc-nao-assinado.06d0bd39.svg";